/* ElbowReliever welcome gift (Pablo, 29 sep): pop-up (pick a box → claim with
   email → code applied to the cart) and the cart timer (<er-reserve>).
   - The pop-up opens on every page view until the visitor has claimed; a side
     tab reopens it after closing. Never auto-opens on cart/account pages or
     while the cart drawer is open.
   - The reservation is real: when the timer ends the code is removed from the
     cart (Ajax Cart API `discount`).
   Markup: sections/er-popup.liquid, snippets/er-cart-reserve.liquid. */
(() => {
  const LS = {
    get(k) {
      try {
        return window.localStorage.getItem(k);
      } catch (e) {
        return null;
      }
    },
    set(k, v) {
      try {
        window.localStorage.setItem(k, v);
      } catch (e) {
        /* private mode: state lives for this page view only */
      }
    },
    del(k) {
      try {
        window.localStorage.removeItem(k);
      } catch (e) {
        /* ignore */
      }
    },
  };
  const K_DONE = 'er-gift-done';
  const K_T0 = 'er-gift-t0';
  const K_PENDING = 'er-gift-pending';
  const K_OPENED = 'er-gift-opened';
  const K_EXPIRED = 'er-gift-expired';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const pad = (n) => String(n).padStart(2, '0');
  const fmt = (ms) => {
    const s = Math.max(0, Math.ceil(ms / 1000));
    return `${Math.floor(s / 60)}:${pad(s % 60)}`;
  };
  const updateUrl = () => `${(window.routes && window.routes.cart_update_url) || '/cart/update'}.js`;

  /* Put a code on the cart ('' removes it). The /discount/ link also covers
     carts that do not exist yet: Shopify keeps it for the checkout. */
  const setDiscount = async (code) => {
    try {
      await fetch(updateUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: code }),
      });
    } catch (e) {
      /* network hiccup: the /discount/ link below still applies it */
    }
    if (code) {
      try {
        await fetch(`/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent('/cart.js')}`, {
          credentials: 'same-origin',
        });
      } catch (e) {
        /* ignore */
      }
    }
  };

  const onCartPage = () => !!document.querySelector('cart-items'); // tag match only: <cart-drawer-items> does not count
  const refreshDrawer = () => {
    const items = document.querySelector('cart-drawer-items');
    if (items && typeof items.onCartUpdate === 'function') items.onCartUpdate();
  };

  /* ---------- Cart timer ---------- */
  class ErReserve extends HTMLElement {
    connectedCallback() {
      if (this.dataset.state === 'unlock') {
        this.hidden = !!LS.get(K_DONE);
        const btn = this.querySelector('[data-er-gift-open]');
        if (btn) btn.addEventListener('click', () => document.dispatchEvent(new CustomEvent('er:gift-open', { detail: { step: 'claim' } })));
        return;
      }
      let t0 = Number(LS.get(K_T0));
      if (!t0) {
        t0 = Date.now();
        LS.set(K_T0, String(t0));
      }
      this.end = t0 + Number(this.dataset.reserve || 15) * 60000;
      this.time = this.querySelector('[data-er-reserve-time]');
      this.msg = this.querySelector('[data-er-reserve-msg]');
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
    }
    async tick() {
      const left = this.end - Date.now();
      if (this.time) this.time.textContent = fmt(left);
      if (left > 0 || this.expired) return;
      this.expired = true;
      clearInterval(this.timer);
      this.classList.add('is-expired');
      if (this.msg) this.msg.textContent = 'Your reserved discount has expired.';
      if (this.time) this.time.hidden = true;
      LS.set(K_EXPIRED, '1');
      await setDiscount('');
      if (onCartPage()) window.location.reload();
      else refreshDrawer();
    }
  }
  if (!customElements.get('er-reserve')) customElements.define('er-reserve', ErReserve);

  /* ---------- Pop-up ---------- */
  const initGift = () => {
    const root = document.querySelector('[data-er-gift]');
    if (!root) return;
    const tab = document.querySelector('[data-er-gift-tab]');
    const form = document.getElementById('ErGiftForm');
    const code = root.dataset.code;
    const reserveMs = Number(root.dataset.reserve || 15) * 60000;
    const err = root.querySelector('[data-er-gift-error]');
    const submitBtn = root.querySelector('[data-er-gift-submit]');
    let lastFocus = null;
    let reloadOnClose = false;
    let doneTimer;

    const show = (name) => {
      root.querySelectorAll('[data-step]').forEach((s) => {
        s.hidden = s.dataset.step !== name;
      });
      root.dataset.current = name;
    };
    const isOpen = () => !root.hidden;
    const focusFirst = () => {
      // Focus the dialog itself on the box step (no focus ring on box 1 when it opens by itself).
      const step = root.querySelector('[data-step]:not([hidden])');
      const el = (step && step.querySelector('input[type="email"], .er-gift__btn')) || root.querySelector('.er-gift__panel');
      if (el) el.focus({ preventScroll: true });
    };
    // Keep Tab inside the dialog while it is open.
    root.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab' || !isOpen()) return;
      const f = [...root.querySelectorAll('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])')].filter(
        (n) => !n.disabled && n.offsetParent !== null
      );
      if (!f.length) return;
      const first = f[0];
      const last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || !root.contains(document.activeElement))) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
    const open = (step) => {
      if (isOpen()) return;
      if (step) show(step);
      lastFocus = document.activeElement;
      root.hidden = false;
      document.body.classList.add('er-gift-open');
      if (tab) tab.hidden = true;
      // rAF for the fade-in; the timeout covers tabs where frames are paused.
      requestAnimationFrame(() => root.classList.add('is-in'));
      window.setTimeout(() => root.classList.add('is-in'), 60);
      focusFirst();
    };
    const close = () => {
      if (!isOpen()) return;
      root.classList.remove('is-in');
      root.hidden = true;
      document.body.classList.remove('er-gift-open');
      if (tab) tab.hidden = !!LS.get(K_DONE);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
      if (reloadOnClose) window.location.reload();
    };

    root.querySelectorAll('[data-er-gift-close]').forEach((b) => b.addEventListener('click', close));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && isOpen()) close();
    });
    if (tab) tab.addEventListener('click', () => open(LS.get(K_OPENED) ? 'claim' : 'pick'));
    document.addEventListener('er:gift-open', (e) => open((e.detail && e.detail.step) || 'claim'));

    /* Step 1: every box holds the same gift. Shake → open (light burst +
       confetti) → ticket. With reduced motion it goes straight to the ticket. */
    const COLORS = ['#ffe700', '#ffffff', '#0079ff', '#ffd400', '#9cc8ff'];
    const burst = (box) => {
      const host = box.querySelector('.er-gift__confetti');
      if (!host || host.childElementCount) return;
      for (let n = 0; n < 26; n += 1) {
        const piece = document.createElement('i');
        const angle = (Math.PI * 2 * n) / 26 + Math.random() * 0.4;
        const dist = 70 + Math.random() * 90;
        piece.style.setProperty('--x', `${Math.cos(angle) * dist}px`);
        piece.style.setProperty('--y', `${Math.sin(angle) * dist - 30}px`);
        piece.style.setProperty('--r', `${Math.round(Math.random() * 540 - 270)}deg`);
        piece.style.setProperty('--c', COLORS[n % COLORS.length]);
        piece.style.setProperty('--d', `${(Math.random() * 0.12).toFixed(2)}s`);
        host.appendChild(piece);
      }
    };
    const resetBoxes = () => {
      root.classList.remove('is-picking');
      root.querySelectorAll('[data-er-gift-box]').forEach((b) => {
        b.classList.remove('is-chosen', 'is-open');
        const host = b.querySelector('.er-gift__confetti');
        if (host) host.textContent = '';
      });
    };
    root.querySelectorAll('[data-er-gift-box]').forEach((box) =>
      box.addEventListener('click', () => {
        if (root.classList.contains('is-picking')) return;
        LS.set(K_OPENED, '1');
        const toClaim = () => {
          show('claim');
          resetBoxes();
          focusFirst();
        };
        if (reduceMotion) return toClaim();
        root.classList.add('is-picking');
        box.classList.add('is-chosen');
        window.setTimeout(() => {
          burst(box);
          box.classList.add('is-open');
        }, 500);
        window.setTimeout(toClaim, 1500);
      })
    );

    /* Step 3 */
    const startDoneTimer = () => {
      const out = root.querySelector('[data-er-gift-left]');
      if (!out) return;
      const t0 = Number(LS.get(K_T0)) || Date.now();
      const tick = () => {
        out.textContent = fmt(t0 + reserveMs - Date.now());
      };
      tick();
      clearInterval(doneTimer);
      doneTimer = setInterval(tick, 1000);
    };
    /* "Checkout now" when the cart has items, otherwise back to the bundles. */
    const goBtn = root.querySelector('[data-er-gift-go]');
    const goLabel = root.querySelector('[data-er-gift-go-label]');
    const setGo = async () => {
      if (!goBtn || !goLabel) return;
      let count = 0;
      try {
        count = (await (await fetch('/cart.js', { credentials: 'same-origin' })).json()).item_count || 0;
      } catch (e) {
        /* keep "shop" */
      }
      goBtn.dataset.mode = count > 0 ? 'checkout' : 'shop';
      goLabel.textContent = count > 0 ? goLabel.dataset.checkout : goLabel.dataset.shop;
    };
    if (goBtn)
      goBtn.addEventListener('click', () => {
        if (goBtn.dataset.mode === 'checkout') {
          window.location.href = '/checkout';
          return;
        }
        const buyBox = document.querySelector('.er-bundles, product-form');
        if (buyBox) {
          reloadOnClose = false;
          close();
          buyBox.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
          return;
        }
        window.location.href = root.dataset.shopUrl || '/collections/all';
      });

    const claimed = async () => {
      LS.set(K_DONE, '1');
      LS.del(K_PENDING);
      LS.del(K_EXPIRED);
      LS.set(K_T0, String(Date.now()));
      await setDiscount(code);
      show('done');
      startDoneTimer();
      setGo();
      document.querySelectorAll('er-reserve[data-state="unlock"]').forEach((el) => {
        el.hidden = true;
      });
      if (onCartPage()) reloadOnClose = true;
      else refreshDrawer();
      document.dispatchEvent(new CustomEvent('er:gift-claimed'));
    };

    /* Step 2: sign up through Shopify's own customer form, as a normal post
       (same as Dawn's newsletter), so Shopify's bot check can step in when
       it wants to. The page comes back with ?customer_posted=true. */
    if (form)
      form.addEventListener('submit', (e) => {
        const email = form.querySelector('input[type="email"]');
        if (!email || !email.checkValidity()) {
          e.preventDefault();
          if (err) err.hidden = false;
          if (email) email.focus();
          return;
        }
        if (err) err.hidden = true;
        LS.set(K_PENDING, '1');
        submitBtn.classList.add('is-loading');
      });

    /* Back from the post: the anchor would scroll to the footer, so undo it. */
    const cleanUrl = () => {
      const u = new URL(window.location.href);
      u.searchParams.delete('customer_posted');
      u.hash = '';
      window.history.replaceState(null, '', u.pathname + u.search);
      window.scrollTo(0, 0);
    };
    if ('posted' in root.dataset && LS.get(K_PENDING) && !LS.get(K_DONE)) {
      cleanUrl();
      open('done');
      claimed();
      return;
    }
    if ('error' in root.dataset && !LS.get(K_DONE)) {
      cleanUrl();
      open('claim');
      if (err) err.hidden = false;
    }
    if (LS.get(K_DONE)) return;
    // Not on the cart page: the cart has its own "Unlock 10%" strip there.
    if (tab) tab.hidden = (root.dataset.template || '') === 'cart';

    const tmpl = root.dataset.template || '';
    const skip = ['cart', 'login', 'register', 'account', 'addresses', 'order', 'activate_account', 'reset_password'];
    if (skip.includes(tmpl)) return;
    const design = window.Shopify && window.Shopify.designMode;
    if (design) {
      if ('preview' in root.dataset) open('pick');
      return;
    }
    const drawerOpen = () => !!document.querySelector('cart-drawer.active, product-modal[open], header-drawer details[open], details.menu-opening');
    // Shopify's cookie banner sits on top: wait until the visitor has answered it.
    const bannerUp = () => {
      const b = document.getElementById('shopify-pc__banner');
      return !!b && b.offsetHeight > 0 && getComputedStyle(b).visibility !== 'hidden';
    };
    let fired = false;
    let waitedForBanner = false;
    const tryOpen = () => {
      if (fired || isOpen()) return;
      if (drawerOpen()) {
        window.setTimeout(tryOpen, 4000);
        return;
      }
      if (bannerUp()) {
        waitedForBanner = true;
        window.setTimeout(tryOpen, 1000);
        return;
      }
      if (waitedForBanner) {
        waitedForBanner = false;
        window.setTimeout(tryOpen, 1500);
        return;
      }
      fired = true;
      open('pick');
    };
    const timer = window.setTimeout(tryOpen, Number(root.dataset.delay || 8) * 1000);
    // Leaving intent (mouse to the top on desktop, a fast flick back up on
    // phones): once per visit the gift comes back if it was closed unclaimed.
    const t0Page = Date.now();
    const secondChance = () => {
      if (!fired || isOpen() || drawerOpen() || bannerUp() || LS.get(K_DONE)) return;
      if (Date.now() - t0Page < 20000) return;
      try {
        if (sessionStorage.getItem('er-gift-exit')) return;
        sessionStorage.setItem('er-gift-exit', '1');
      } catch (e) { return; }
      open('pick');
    };
    document.documentElement.addEventListener('mouseleave', (e) => {
      if (e.clientY <= 0) secondChance();
    });
    let lastY = window.scrollY;
    let upFrom = null;
    let lastInput = 0;
    ['touchmove', 'wheel'].forEach((ev) => window.addEventListener(ev, () => (lastInput = Date.now()), { passive: true }));
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      const t = Date.now();
      if (t - lastInput > 600 || t - (window.__erAnchorScroll || 0) < 2000) {
        upFrom = null;
        lastY = y;
        return;
      }
      if (y >= lastY) upFrom = null;
      else if (!upFrom || t - upFrom.t > 500) upFrom = { y: lastY, t };
      else if (upFrom.y - y > window.innerHeight * 1.2 && y > 400) {
        upFrom = null;
        secondChance();
      }
      lastY = y;
    }, { passive: true });
    document.documentElement.addEventListener('mouseleave', (e) => {
      if (e.clientY <= 0 && !fired) {
        window.clearTimeout(timer);
        tryOpen();
      }
    });
  };

  /* ---------- Reminder pill: the real expiry on every page after claiming ----------
     Hidden while the pop-up is open (it has its own timer) and on the cart page
     (the cart timer shows it there). At zero the code leaves the cart. */
  const initPill = () => {
    const pill = document.querySelector('[data-er-gift-pill]');
    const root = document.querySelector('[data-er-gift]');
    if (!pill || !root) return;
    const out = pill.querySelector('[data-er-pill-left]');
    const reserveMs = Number(root.dataset.reserve || 15) * 60000;
    const onCart = root.dataset.template === 'cart';
    let timer;
    const lift = () => {
      const bar = document.querySelector('[data-er-sticky].is-visible');
      pill.style.setProperty('--er-pill-lift', bar ? `${Math.round(bar.getBoundingClientRect().height)}px` : '0px');
    };
    const tick = async () => {
      const t0 = Number(LS.get(K_T0));
      if (!LS.get(K_DONE) || !t0 || LS.get(K_EXPIRED)) {
        pill.hidden = true;
        return;
      }
      const left = t0 + reserveMs - Date.now();
      if (left <= 0) {
        pill.hidden = true;
        clearInterval(timer);
        LS.set(K_EXPIRED, '1');
        await setDiscount('');
        refreshDrawer();
        return;
      }
      if (out) out.textContent = fmt(left);
      pill.hidden = onCart || !root.hidden;
      lift();
    };
    tick();
    timer = setInterval(tick, 1000);
    document.addEventListener('er:gift-claimed', () => {
      clearInterval(timer);
      timer = setInterval(tick, 1000);
    });
  };

  const init = () => {
    initGift();
    initPill();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
